/* eslint-disable */
// Slightly modified from https://gist.github.com/andjosh/6764939
export default function easeInOutQuad(time, start, change, duration) {
  time /= duration / 2;
  if (time < 1) return change / 2 * time * time + start;
  time--;
  return -change / 2 * (time * (time - 2) - 1) + start;
}
/* eslint-enable */